var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5473 7.87512H10.6255C10.1779 7.87512 9.74871 7.69733 9.43225 7.38086C9.11578 7.0644 8.93799 6.63517 8.93799 6.18762V1.26575C8.93799 1.22845 8.92317 1.19268 8.8968 1.16631C8.87043 1.13994 8.83466 1.12512 8.79736 1.12512H5.56299C4.96625 1.12512 4.39396 1.36218 3.972 1.78413C3.55004 2.20609 3.31299 2.77839 3.31299 3.37512V14.6251C3.31299 15.2219 3.55004 15.7942 3.972 16.2161C4.39396 16.6381 4.96625 16.8751 5.56299 16.8751H13.438C14.0347 16.8751 14.607 16.6381 15.0289 16.2161C15.4509 15.7942 15.688 15.2219 15.688 14.6251V8.01575C15.688 7.97845 15.6731 7.94268 15.6468 7.91631C15.6204 7.88994 15.5846 7.87512 15.5473 7.87512Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2387 6.63114L10.1828 1.57532C10.173 1.56554 10.1605 1.55889 10.1469 1.55621C10.1333 1.55352 10.1192 1.55491 10.1064 1.56021C10.0936 1.5655 10.0826 1.57447 10.0749 1.58598C10.0672 1.59749 10.063 1.61102 10.063 1.62489V6.18852C10.063 6.33771 10.1222 6.48078 10.2277 6.58627C10.3332 6.69176 10.4763 6.75102 10.6255 6.75102H15.1891C15.203 6.75096 15.2165 6.74681 15.228 6.73908C15.2395 6.73135 15.2485 6.72039 15.2538 6.70758C15.2591 6.69477 15.2605 6.68067 15.2578 6.66707C15.2551 6.65347 15.2484 6.64097 15.2387 6.63114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentwhite);
export default __webpack_public_path__ + "static/media/Documentwhite.34e53bbb723f5dce9af457f32c797fd3.svg";
export { ForwardRef as ReactComponent };